import { Divider, List, ListItemText } from "@mui/material";
import { JSXElementConstructor, ReactNode, createElement } from "react";

import { UserTypeItem } from "@/constants/userTypes";
import { UserType } from "@/types/user.types";

import CommonTooltip from "./CommonTooltip";
import DriverAvatar from "./DriverAvatar";

function UserTooltipList<T extends { name: string; id: string; userType?: UserType; disabled?: boolean }>({
    item,
    users,
    description,
    children,
    userType,
    extraInfo,
}: {
    item: UserTypeItem;
    users: T[];
    description?: string;
    children?: ReactNode;
    userType?: UserType;
    extraInfo?: JSXElementConstructor<{ user: T }>;
}) {
    if (!users) return null;
    else if (!users.length) return children;
    return (
        <CommonTooltip
            tooltip={{
                ...item,
                tooltip: {
                    title: "Kullanıcılar",
                    description: description || "",
                },
            }}
            tooltipChild={
                <List dense sx={{ padding: "0px !important" }} className=" !min-w-fit">
                    {users.map((user) => {
                        return (
                            <ListItemText
                                key={user.id}
                                className="px-2 py-1 "
                                primary={
                                    <>
                                        <div className="flex items-center justify-between w-full px-2 mr-2 whitespace-nowrap   min-w-fit">
                                            <DriverAvatar
                                                avatar
                                                userType={user.userType || userType}
                                                isDeleted={user.disabled}
                                                name={user.name}
                                            />
                                            {extraInfo && createElement(extraInfo, { user })}
                                        </div>
                                        <Divider />
                                    </>
                                }
                            />
                        );
                    })}
                </List>
            }
        >
            {children}
        </CommonTooltip>
    );
}
export default UserTooltipList;
